export const footerModalsNames = {
  confirmDataTypeChange: 'confirmDataTypeChange',
  replaceWithPublishedAttribute: 'replaceWithPublishedAttribute',
} as const;
